// extracted by mini-css-extract-plugin
export default {"price_wrapper":"PriceTable_price_wrapper__vjLZU","row":"PriceTable_row__kxO55","total_price":"PriceTable_total_price__RAk+Y"};